import { render, staticRenderFns } from "./SearchStandardisedProfiles.vue?vue&type=template&id=38e08d8b&scoped=true"
import script from "./SearchStandardisedProfiles.vue?vue&type=script&lang=ts"
export * from "./SearchStandardisedProfiles.vue?vue&type=script&lang=ts"
import style0 from "./SearchStandardisedProfiles.vue?vue&type=style&index=0&id=38e08d8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e08d8b",
  null
  
)

export default component.exports